// @flow
import { RichText } from "prismic-reactjs";
import { Helmet } from "react-helmet";

type Props = {
  post: PrismicPost,
};

const MetaTags = ({ post }: Props) => (
  <Helmet>
    <title>{RichText.asText(post.data.title)} | Nested blog</title>
    <meta property="og:title" content={RichText.asText(post.data.title)} />
    <meta
      property="og:description"
      content={RichText.asText(post.data.description)}
    />
    <meta property="og:image" content={post.data.hero_image.url} />
    <meta
      property="og:url"
      content={`https://nested.com/blog/posts/${post.uid}`}
    />
    <meta property="og:type" content="article" />
    <meta
      property="article:published_time"
      content={post.first_publication_date}
    />
  </Helmet>
);

export { MetaTags };
